// extracted by mini-css-extract-plugin
export default {"accordion":"WvYHe","disabled":"OJbS9","header":"Ofa0b","collapsed":"QQ0kK","content":"VehDr"};